const API_BASE = "https://ricgop.online/api";

export const loginAdmin = async (email, password) => {
  const res = await fetch(`${API_BASE}/admin-login.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return res.json();
};

export const fetchDashboardStats = async () => {
  const res = await fetch(`${API_BASE}/admin-dashboard-stats.php`);
  return res.json();
};
